import Phaser from 'phaser';
import { addCrispText } from '../ui/textHelper';
import { ASSET_MANIFEST } from '../content/assets';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    // Characters
    this.load.image('croupier', 'assets/croupier.png');
    this.load.image('shopkeeper', 'assets/shopkeeper.png');
    // Balls (key = ball-{defId})
    // Legacy 32×32 ball/fiche/relic sprites removed — all superseded by 128×128
    // sprites in assets/sprites/ loaded via ASSET_MANIFEST below.

    // Phase 17 manifest sprites — single loaderror handler removes any partially-registered
    // texture so downstream textures.exists() guards correctly fall back to shapes.
    this.load.on('loaderror', (file: Phaser.Loader.File) => {
      if (this.textures.exists(file.key)) {
        this.textures.remove(file.key);
      }
    });
    for (const entry of ASSET_MANIFEST) {
      this.load.image(entry.key, entry.path);
    }

    // Tetris fiche spritesheet: 7 frames × 128×128px (I, O, T, S, Z, J, L)
    this.load.spritesheet('tetris-fiches', 'assets/spritesheets/tetris_v2.png', {
      frameWidth: 128,
      frameHeight: 128,
    });
    // Chess fiche spritesheet: 6 frames × 128×128px (pawn, knight, bishop, rook, queen, king)
    this.load.spritesheet('chess-fiches', 'assets/spritesheets/chess.png', {
      frameWidth: 128,
      frameHeight: 128,
    });
    // Boss spritesheets: 3 frames × 375×250px each
    this.load.spritesheet('bosses-1', 'assets/spritesheets/boss_1.png', {
      frameWidth: 375,
      frameHeight: 250,
    });
    this.load.spritesheet('bosses-2', 'assets/spritesheets/boss_2.png', {
      frameWidth: 375,
      frameHeight: 250,
    });
    this.load.spritesheet('bosses-3', 'assets/spritesheets/boss_3.png', {
      frameWidth: 375,
      frameHeight: 250,
    });
    // Ball spritesheet: 5 frames × 128×128px (standard, red, magnet, lucky, splash)
    this.load.spritesheet('balls', 'assets/spritesheets/balls.png', {
      frameWidth: 128,
      frameHeight: 128,
    });
    // Relic spritesheets: 128×80px per frame (landscape, auto-trimmed per frame)
    this.load.spritesheet('relics-1', 'assets/spritesheets/relics_1.png', {
      frameWidth: 128,
      frameHeight: 80,
    });
    this.load.spritesheet('relics-2', 'assets/spritesheets/relics_2.png', {
      frameWidth: 128,
      frameHeight: 80,
    });
    this.load.spritesheet('relics-3', 'assets/spritesheets/relics_3.png', {
      frameWidth: 128,
      frameHeight: 80,
    });
    // Consumable spritesheets: cocktail art, 128×128px per frame
    this.load.spritesheet('consumables-1', 'assets/spritesheets/consumables_1.png', {
      frameWidth: 128,
      frameHeight: 128,
    });
    this.load.spritesheet('consumables-2', 'assets/spritesheets/consumables_2.png', {
      frameWidth: 128,
      frameHeight: 128,
    });
    this.load.spritesheet('consumables-3', 'assets/spritesheets/consumables_3.png', {
      frameWidth: 128,
      frameHeight: 128,
    });
    // Misc fiche spritesheets: 6 frames × 128×128px each
    this.load.spritesheet('misc-fiches-1', 'assets/spritesheets/misc_1.png', {
      frameWidth: 128,
      frameHeight: 128,
    });
    this.load.spritesheet('misc-fiches-2', 'assets/spritesheets/misc_2.png', {
      frameWidth: 128,
      frameHeight: 128,
    });
    this.load.spritesheet('misc-fiches-3', 'assets/spritesheets/misc_3.png', {
      frameWidth: 128,
      frameHeight: 128,
    });
  }

  create(): void {
    // Show the scene name briefly so the developer can see Boot rendered.
    addCrispText(this, this.scale.width / 2, this.scale.height / 2, 'Boot', {
      fontFamily: 'system-ui, -apple-system, sans-serif',
      fontSize: '32px',
      color: '#ffffff',
    }).setOrigin(0.5);

    // Auto-advance to Menu on the next tick (matches CONTEXT.md: "after a single tick").
    this.time.delayedCall(0, () => {
      this.scene.start('MenuScene');
    });
  }
}
